class GiftWrapping extends HTMLElement {
  constructor() {
    super()

    this.elements = {
      form: this.querySelector('[data-gift-wrapping-el="form"]'),
      submitButton: this.querySelector('[data-gift-wrapping-el="submitButton"]'),
    }

    this.state = {
      added: false,
    }

    this.cartItems = document.querySelector('cart-items')
  }

  connectedCallback() {
    this.setupEventListeners()
    this.checkIfInCart()
  }

  setupEventListeners() {
    this.elements.form.addEventListener('submit', this.handleSubmit.bind(this))
  }

  handleSubmit(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.getAttribute('data-is-in-cart') === 'true') {
      this.removeFromCart()
    } else {
      this.addProduct()
    }
  }

  checkIfInCart() {
    if (this.getAttribute('data-is-in-cart') === 'true' && this.cartItemCount === 1) {
      this.removeFromCart()
    }
  }

  async addProduct() {
     const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        sections: this.cartItems.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
        items: [
          {
            id: Number(this.dataset.productId),
            quantity: 1,
          },
        ],
      }),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()

    this.cartItems?.renderContents(data)
  }

  async removeFromCart() {
    const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        sections: this.cartItems.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
        id: this.lineKey,
        quantity: 0,
      }),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()

    this.cartItems?.renderContents(data)
  }

  get cartItemCount() {
    return Number(this.dataset.cartItemCount)
  }

  get lineKey() {
    return this.dataset.lineKey
  }

  get cartItemCount() {
    return Number(this.dataset.cartItemCount)
  }

  get added() {
    return this.state.added
  }

  set added(value) {
    this.state.added = value
    this.setAttribute('data-is-in-cart', value.toString())
  }
}

customElements.define('gift-wrapping', GiftWrapping)
